var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "dashboard", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        { staticClass: "dashContent" },
        [
          _c("b-col", { attrs: { md: "3" } }, [
            _c("div", { staticClass: "userProfile" }, [
              _c("img", {
                staticClass: "avatar",
                attrs: { src: "/public/images/anonymous.jpg" },
              }),
              _vm._v(" "),
              _c("h5", { staticClass: "greetings" }, [_vm._v("Sugeng Rawuh,")]),
              _vm._v(" "),
              _c("h4", [_vm._v("Kang Mimin")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "menuBar" },
              [
                _c(
                  "b-nav",
                  { attrs: { vertical: "" } },
                  [
                    _c("b-nav-item", { attrs: { to: "/list" } }, [
                      _vm._v("Participant List"),
                    ]),
                    _vm._v(" "),
                    _c("b-nav-item", { attrs: { to: "/maileditor" } }, [
                      _vm._v("E-mail Editor"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.contents, function (content, index) {
                  return _c(
                    "b-nav",
                    {
                      key: index,
                      staticClass: "mt-2",
                      attrs: { vertical: "", data: content },
                    },
                    [
                      _c(
                        "b-nav-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.selected(content)
                            },
                          },
                        },
                        [_vm._v(_vm._s(content.subject))]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "9" } },
            [
              _c(
                "div",
                { staticClass: "clearfix mailEditor" },
                [
                  _c("b-form-input", {
                    attrs: { placeholder: "Authentication Key" },
                    model: {
                      value: _vm.target.key,
                      callback: function ($$v) {
                        _vm.$set(_vm.target, "key", $$v)
                      },
                      expression: "target.key",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { placeholder: "Target E-mail address" },
                    model: {
                      value: _vm.target.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.target, "email", $$v)
                      },
                      expression: "target.email",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { placeholder: "Subject" },
                    model: {
                      value: _vm.target.subject,
                      callback: function ($$v) {
                        _vm.$set(_vm.target, "subject", $$v)
                      },
                      expression: "target.subject",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-select", {
                    staticClass: "mb-4",
                    attrs: { options: _vm.templates },
                    model: {
                      value: _vm.target.template,
                      callback: function ($$v) {
                        _vm.$set(_vm.target, "template", $$v)
                      },
                      expression: "target.template",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "quill",
                        rawName: "v-quill:myQuillEditor",
                        value: _vm.editorOption,
                        expression: "editorOption",
                        arg: "myQuillEditor",
                      },
                    ],
                    staticClass: "quill-editor",
                    model: {
                      value: _vm.target.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.target, "content", $$v)
                      },
                      expression: "target.content",
                    },
                  }),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.status))]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.send } },
                [_vm._v("Send")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { attrs: { variant: "warning" }, on: { click: _vm.save } },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/MailEditor.vue